import { isArketBrand } from "@pb/utils/brandConfig";
import { isCosBrand } from "@pb/utils/brandConfig";
import { isOtherStoriesBrand } from "@pb/utils/brandConfig";
import { isMonkiBrand } from "@pb/utils/brandConfig";
export const getActiveNibSmsMarkets = () => {
    const storiesMarkets = [
        'SE',
        'AT',
        'DK',
        'FR',
        'DE',
        'IE',
        'IT',
        'NL',
        'NO',
        'ES',
        'GB',
        'BE',
        'FI',
    ];
    const arketMarkets = ['NL', 'GB', 'DK', 'SE', 'NO', 'DE'];
    const cosMarkets = ['SE', 'GB', 'DE', 'FR', 'NL', 'DK', 'IE', 'IT', 'ES', 'PL', 'AT', 'CH', 'NO'];
    const monkiMarkets = [
        'SE',
        'AT',
        'WW',
        'BE',
        'BG',
        'HR',
        'CY',
        'CZ',
        'DK',
        'EE',
        'FI',
        'FR',
        'DE',
        'GR',
        'HU',
        'IE',
        'IT',
        'LV',
        'LT',
        'LU',
        'NO',
        'PL',
        'PT',
        'RO',
        'SK',
        'SI',
        'ES',
        'CH',
        'GB',
        'NL',
    ];
    if (isArketBrand) {
        return arketMarkets;
    }
    if (isCosBrand) {
        return cosMarkets;
    }
    if (isOtherStoriesBrand) {
        return storiesMarkets;
    }
    if (isMonkiBrand) {
        return monkiMarkets;
    }
    return ['SE'];
};
//# sourceMappingURL=getActiveNibSmsMarkets.js.map